export default __webpack_public_path__ + "static/international-metric-mobile-c39d08062387a2c84b5107bdb9e76f68.svg";